import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  showHeaderBg: boolean
  headerRef: React.RefObject<HTMLElement> | null
}

interface Action {
  /* eslint-disable no-unused-vars */
  setShowHeaderBg: (showHeaderBg: State['showHeaderBg']) => void
  setHeaderRef: (ref: React.RefObject<HTMLElement>) => void
}
/* eslint-enable */

const baseStorePageElements = create<State & Action>((set) => ({
  showHeaderBg: false,
  headerRef: null,
  setShowHeaderBg: (showHeaderBg) => set({ showHeaderBg }),
  setHeaderRef: (ref) => set({ headerRef: ref })
}))

const useStorePageElements = createSelectors(baseStorePageElements)

export default useStorePageElements
